import request from "../../config/axios";

const getOrderById = (order_id) => {
  return request.get(`/wp-json/wc/v3/orders/${order_id}`);
};

export { getOrderById };

// Ví dụ thanh toán faild thì có lấy đơn hàng ra được không